/*
 * App reducer
 */

// App state is stored as { global: {} } in redux store (see app/reducers.js)

import produce from "immer";

import {
  FETCH_USER_DATA_BEGIN,
  FETCH_USER_DATA_ERROR,
  FETCH_USER_DATA_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  SET_USER_DATA,
} from "containers/Shared/App/constants";

// The initial state of the App
export const initialState = {
  token: null,
  data: null,
  isFetchingUserData: true,
  fetchUserDataError: false,
};

function appReducer(state = initialState, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case LOGIN_SUCCESS:
        draft.token = action.token;
        break;
      case LOGOUT_SUCCESS:
        draft.token = initialState.token;
        draft.data = { enterprise: draft.data?.enterprise };
        break;
      case SET_USER_DATA:
        if (action.append === true) {
          draft.data = { ...draft.data, ...action.payload };
        } else {
          draft.data = action.payload;
        }
        break;
      case FETCH_USER_DATA_BEGIN:
        draft.isFetchingUserData = true;
        draft.fetchUserDataError = false;
        break;
      case FETCH_USER_DATA_SUCCESS:
        draft.isFetchingUserData = false;
        break;
      case FETCH_USER_DATA_ERROR:
        draft.isFetchingUserData = false;
        draft.fetchUserDataError = true;
        break;
    }
  });
}

export default appReducer;
